import { useState, useEffect } from 'react'
import { Stack, Typography } from '@vapor/material'
import useFormatDate from 'src/app/hooks/current-locale/use-format-date'
import HicAmountField from 'src/app/components/hic-amount-field/hic-amount-field'
import { useTenant } from 'src/app/hooks/context/context.hook'

type DatePriceProps = {
  date: Date
  amount: number
  onChange: (v: number) => void
}

export const DatePrice = (props: DatePriceProps) => {
  const { date, amount, onChange } = props
  const { currency } = useTenant()
  const formatDate = useFormatDate()

  const [internalAmount, setInternalAmount] = useState(amount)
  const [isTouched, setIsTouched] = useState(false)

  useEffect(() => {
    if (internalAmount !== amount) setInternalAmount(amount)
  }, [amount])

  const onChangeHandler = (value: number | null) => {
    try {
      if (value) onChange(value)
    } catch (e) {
      console.log('Not numeric value')
    }
  }

  return (
    <Stack direction="row" spacing={2} sx={{ with: 400, alignItems: 'center', my: 1 }}>
      <Typography variant="body">{formatDate(date)}</Typography>
      <HicAmountField
        size="small"
        value={amount}
        currency={currency}
        onBlur={() => {
          if (isTouched) {
            onChangeHandler(internalAmount)
            setIsTouched(false)
          }
        }}
        onChange={(value) => {
          const tmpPrice = value
          if ((tmpPrice || tmpPrice === 0) && tmpPrice !== internalAmount) {
            setIsTouched(true)
            setInternalAmount(tmpPrice)
          }
        }}
      />
    </Stack>
  )
}
